//dependencias
import React, { Component } from 'react';

//componentes
import BecadosAction from './becados'

class Index extends Component {

    render(){
        return(
            <div>
                <BecadosAction />
            </div>
        );
    }

}
export default Index;